import { Injectable } from '@angular/core';
import {MetodosServicio} from "../../../_helpers/interfaces/metodos-servicio";
import {SolicitudCreditoEstado} from "../../../_models/solicitud-credito-estado";
import {HttpClient} from "@angular/common/http";
import {SettingsService} from "../../../services/settings.service";

@Injectable({
  providedIn: 'root'
})
export class SolicitudCreditoEstadoService extends MetodosServicio<SolicitudCreditoEstado>{

  constructor(
    public http: HttpClient,
    private settings: SettingsService
  ) {
    super(http, 'public/solicitud_credito_estado', SolicitudCreditoEstado);
  }

  restartItem(): void {
    this.setItem(new SolicitudCreditoEstado());
  }

}
